import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentGettingStartedFacade } from '@core/tellent-getting-started-data';
import { TellentAdoptedStylesheetsDirective, TellentThemeDirective } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { BoldTextPipe, RtTooltip } from '@core/user-interface-legacy';
import {
  SingleLineWalkthroughTooltipComponent,
  TooltipType,
  WalkthroughTriggerButtonComponent,
} from '@core/walkthrough-legacy';

@Component({
  selector: 'x-getting-started-trigger',
  template: `
    @let visible = svc.isDrawerTriggerVisible();

    @if (visible) {
      @let progerssPct = svc.progressPct();
      @let tooltipTemplate = progerssPct > 0 ? gettingStartedProgressTooltipTemplate : null;

      <rt-single-line-walkthrough-tooltip [tooltipType]="TooltipType.FirstTimeDrawerClose">
        <rt-walkthrough-trigger-button
          rtTooltip
          rtTooltipPosition="below"
          [rtTooltipTemplate]="tooltipTemplate"
          [progress]="progerssPct"
          >{{ 'app.walkthrough.trigger.label' | translate }}
        </rt-walkthrough-trigger-button>
      </rt-single-line-walkthrough-tooltip>

      <ng-template #gettingStartedProgressTooltipTemplate>
        <span
          [innerHtml]="
            'app.walkthrough.trigger.tooltip' | translate: { progress: progerssPct } | boldText
          "
        ></span>
      </ng-template>
    }
  `,
  styleUrls: ['../../../styles.less'],
  styles: `
    :host {
      display: contents;
    }
  `,
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RtTooltip,
    SingleLineWalkthroughTooltipComponent,
    TranslatePipe,
    WalkthroughTriggerButtonComponent,
    BoldTextPipe,
  ],
})
export class TellentGettingStartedTriggerWrapComponent {
  protected readonly TooltipType = TooltipType;
  public readonly svc = inject(TellentGettingStartedFacade);
}

export type TellentGettingStartedTriggerWebComponent = TellentWebComponent<
  TellentGettingStartedTriggerWrapComponent,
  never
>;
